export default __webpack_public_path__ + "static/media/A4AC3FE0-A817-41E5-A40B-468C3D4AC5B2.b95cde4d.jpeg";